class cryptActive{
  constructor(){
    this.crypto = "ChY9nTELOv";
  }

  /**
   *
   * @param data
   * @returns {*|CipherParams}
   */
  encrypt ( data ) {
    return CryptoJS.AES.encrypt(
      JSON.stringify( data ),
      this.crypto
    ).toString();
  }

  /**
   *
   * @param encryptedString
   */
  decrypt ( encryptedString ){
    const bytes  = CryptoJS.AES.decrypt(
      encryptedString.toString(),
      this.crypto
    );
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  };
}

export default cryptActive;


/** WEBPACK FOOTER **
 ** ./frontend/@/crypt.active.js
 **/